<div class="p-20">
    <div id="klarna-box"></div>

    <div class="mt-20 d-flex justify-content-between align-items-center">
        <button class="width-100p" nz-button nzType="primary" [nzLoading]="confirmLoading" [disabled]="disableConfirm" (click)="confirm()">
            Continue
        </button>
    </div>
</div>
